


















import Modal from "../core/Modals/Modal.vue";
import EditionModal from "../core/Modals/EditionModal.vue";
import { EmployeApi } from "../api/EmployeApi";
import { Employe } from "../models/Employe";
import AvenantModalEdit from "./AvenantModalPartials/AvenantModalEdit.vue";
import Avenant = Employe.Avenant;

export default {
    name: "AvenantModal",
    components: { AvenantModalEdit, EditionModal, Modal },
    props: {
        avenantId: Number,
        contratId: Number,
        employeId: Number,
        isNew: Boolean,
    },
    data() {
        return {
            showModal: false,
            avenant: null,
            fetching: true,
            editing: false,
            EmployeApi: new EmployeApi(),
            editable: true,
            saving: false,
        };
    },
    created() {
        var self = this;
    },
    watch: {
        avenantId: function (newVal): void {
            var self = this;

            self.showModal = _.isNumber(newVal) && _.isNumber(this.contratId);
            if (self.showModal) {
                self.fetching = true;
                self.EmployeApi.getAvenant(
                    self.employeId,
                    self.contratId,
                    self.avenantId
                ).then(function (res) {
                    self.avenant = res;
                    self.fetching = false;
                    self.editing = true;
                });
            }
        },
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.avenant = new Avenant({});
                    this.creationModal();
                }
            },
        },
    },
    methods: {
        closeModal: function (): void {
            this.showModal = false;
        },
        saveAvenant: function (): Promise<Avenant> {
            let self = this;
            if (!self.formIsComplete()) {
                swal(
                    "Erreur lors de la sauvegarde.",
                    "Données incomplètes.",
                    "error"
                );
                return;
            }
            if (self.saving) {
                return;
            } else {
                self.saving = true;
            }
            return self.EmployeApi.saveAvenant(
                self.employeId,
                self.contratId,
                self.avenant
            ).then(function (res) {
                self.$emit("data-saved", self.avenant);
                self.saving = false;
                return res;
            });
        },
        creationModal: function (): void {
            this.showModal = true;
            this.fetching = false;
            this.editing = true;
        },
        formIsComplete(): boolean {
            return this.avenant.start_date && this.avenant.hours;
        },
    },
};
